import { Space, Tag, Tooltip, Typography } from 'antd';
import { LockOutlined, CheckCircleTwoTone, StopOutlined } from '@ant-design/icons';
import { MATERIAL_FAMILY_OPTIONS, MATERIAL_FAMILY_COLOR } from './itemConfigConstants';

const { Text } = Typography;

const FAMILY_LABEL = Object.fromEntries(
  MATERIAL_FAMILY_OPTIONS.map((o) => [o.value, o.label])
);

function templateSummary(td) {
  if (!td || typeof td !== 'object') return null;
  const bits = [];
  if (td.defaultUomCode)  bits.push(<Tag key="uom" color="blue">{td.defaultUomCode}</Tag>);
  if (td.measurementMode) bits.push(
    <Tag key="meas" color="geekblue">{td.measurementMode.replace('_based', '')}</Tag>
  );
  if (td.pricingMethod)   bits.push(
    <Tag key="price" color="purple">{td.pricingMethod.replace('_based', '')}</Tag>
  );
  if (!bits.length) return <Text type="secondary">—</Text>;
  return (
    <Tooltip title={
      <pre style={{ margin: 0, fontSize: 11 }}>{JSON.stringify(td, null, 2)}</pre>
    }>
      <Space size={4} wrap>{bits}</Space>
    </Tooltip>
  );
}

export function buildMaterialTypeColumns({ currentPage, pageSize } = {}) {
  return [
    {
      title: '#', key: '__sno__', width: 56, align: 'center', fixed: 'left',
      render: (_v, _r, idx) => {
        const cp = Number(currentPage) > 0 ? Number(currentPage) : 1;
        const ps = Number(pageSize)    > 0 ? Number(pageSize)    : 25;
        return <span className="erp-grid__muted">{(cp - 1) * ps + idx + 1}</span>;
      }
    },
    {
      title: 'Code', key: 'materialTypeCode', dataIndex: 'materialTypeCode',
      sortField: 'material_type_code', sorter: true,
      width: 200, fixed: 'left', dataType: 'string',
      render: (v) => v
        ? <code className="erp-grid__code">{v}</code>
        : <span className="erp-grid__muted">—</span>
    },
    {
      title: 'Name', key: 'materialTypeName', dataIndex: 'materialTypeName',
      sortField: 'material_type_name', sorter: true,
      width: 220, ellipsis: true, dataType: 'string',
      render: (v) => <span className="erp-grid__primary">{v}</span>
    },
    {
      title: 'Family', key: 'materialFamily', dataIndex: 'materialFamily',
      sortField: 'material_family', sorter: true,
      filterField: 'material_family',
      width: 130, dataType: 'enum',
      filters: MATERIAL_FAMILY_OPTIONS.map((o) => ({ text: o.label, value: o.value })),
      render: (v) => v
        ? <Tag color={MATERIAL_FAMILY_COLOR[v] || 'default'} className="erp-grid__tag">
            {FAMILY_LABEL[v] || v}
          </Tag>
        : <span className="erp-grid__muted">—</span>
    },
    {
      title: 'Default Category', key: 'defaultCategoryCode', dataIndex: 'defaultCategoryCode',
      sortField: 'default_category_code',
      width: 200, ellipsis: true, dataType: 'string',
      render: (v) => v
        ? <code className="erp-grid__code">{v}</code>
        : <span className="erp-grid__muted">—</span>
    },
    {
      title: 'Template', key: '__template__', dataIndex: 'templateDefaults',
      width: 240,
      render: (v) => templateSummary(v)
    },
    {
      title: 'System', key: 'isSystem', dataIndex: 'isSystem',
      sortField: 'is_system', filterField: 'is_system',
      width: 100, align: 'center', dataType: 'boolean',
      filters: [{ text: 'System', value: 'true' }, { text: 'User', value: 'false' }],
      render: (v) => v
        ? <Tag icon={<LockOutlined />} color="default" className="erp-grid__tag">System</Tag>
        : <span className="erp-grid__muted">User</span>
    },
    {
      title: 'Status', key: 'isActive', dataIndex: 'isActive',
      sortField: 'is_active', filterField: 'is_active',
      width: 110, align: 'center', dataType: 'boolean',
      filters: [{ text: 'Active', value: 'true' }, { text: 'Inactive', value: 'false' }],
      render: (v) => v
        ? <Tag icon={<CheckCircleTwoTone twoToneColor="#52c41a" />} color="success" className="erp-grid__tag">Active</Tag>
        : <Tag icon={<StopOutlined />} color="default" className="erp-grid__tag">Inactive</Tag>
    }
  ];
}
